import React, { useState } from 'react';
import { Button, Modal, Select, Text, Input } from 'v3/components';
import { fetchUserByEmail } from 'utils/fetches';
import { useSnackbar } from 'v3/components/Snackbar';
import { cooperplaceApi } from 'services/api';
import { filtersMapper, useFleetManagement } from '../../shared';
import { BodyContainer } from './styles';

function SendEmailsModal() {
  const { sendEmailsModal: modalHook, loading, filters, rowsPerPage } = useFleetManagement();
  const [emails, setEmails] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const snackbar = useSnackbar();

  const handleClose = () => {
    setEmails([]);
    modalHook.close();
  };

  function extractValidEmail(input) {
    const part = input.split(/[;, \t\r\n]+/).filter((p) => p.trim() !== '');

    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const emailValid = part.filter((email) => regexEmail.test(email));

    return emailValid;
  }

  const handleSendEmails = async () => {
    setIsFetching(true);
    try {
      const formarEmails = extractValidEmail(emails);

      await cooperplaceApi.post('fleet/management/vehicleManagement/email', {
        emails: formarEmails,
        ...filtersMapper(filters, rowsPerPage),
      });
      snackbar.show(<Text>Emails enviados com sucesso</Text>, {
        type: 'success',
      });
    } catch (error) {
      snackbar.show(
        <Text>{error?.response?.data?.error || 'Erro ao enviar relatório por e-mail'}</Text>,
        {
          type: 'error',
        },
      );
    } finally {
      setIsFetching(false);
      handleClose();
    }
  };

  return (
    <Modal
      show={modalHook.isOpen}
      heading="Enviar relatório por e-mail"
      body={
        <BodyContainer>
          <Text type="subtitle" className="text-title">
            Enviar emails:
          </Text>

          <Text>
            Adicione todos os emails dos usuários que gostaria que fosse enviado um relatório por
            e-mail
          </Text>

          <Input
            value={emails}
            label="Emails dos usuários"
            onChange={(e) => setEmails(e.target.value)}
          />

          <Button loading={loading || isFetching} onClick={handleSendEmails} modal>
            Enviar emails
          </Button>
        </BodyContainer>
      }
      handleClose={handleClose}
    />
  );
}

export default SendEmailsModal;
